import { MethodsEnum } from "../enums/Methods.ts";
import { TipoCirurgia } from "../models/TipoCirurgia.ts";
import handleService from "./apiService.ts";

const create = async (tipoCirurgia: TipoCirurgia) => {
  // id nunca deve ser enviado num cadastro novo - ver pacienteService.create para o motivo.
  const { id, ...tipoCirurgiaSemId } = tipoCirurgia as any;
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/tipo-cirurgia",
    data: tipoCirurgiaSemId,
  });
  return result;
};

const update = async (tipoCirurgia) => {
  const result = await handleService({
    method: MethodsEnum.PATCH,
    endpoint: "/tipo-cirurgia/alterar",
    data: tipoCirurgia,
  });
  return result;
};

const tipoCirurgiaService = { create, update };

export default tipoCirurgiaService;
